import { IncentiveRadio } from "../baseComponents/IncentiveRadio/IncentiveRadio";
import CalculateThreshold from "../components/CalculateThreshold";
import { DefineIncentivePreview } from "../components/DefineIncentivePreview";
import { IncentiveCalculationType } from "../components/IncentiveCalculationType";
import { IncentivePeriod } from "../components/IncentivePeriod";
import { IncentiveTextBox } from "../baseComponents/IncentiveTextBox";
import { KpiSelection } from "../components/KpiSelection";
import { UserSelection } from "../components/UserSelection";
import { ValidityDate } from "../components/ValidityDate";
import { IncentiveName } from "../components/IncentiveName";
import { CreateIncentivePreview } from "../components/CreateIncentivePreview";

export const tabConfig: TabConfig[] = [
    {
        tabName: "Define Incentive",
        tabDefinition: {
            tabComponents: [
                {
                    label: "Incentive Calculation On",
                    component: IncentiveCalculationType,
                    stateName: "calculationType"
                },
                {
                    label: "What Period Should The Incentive Be Calculated On",
                    component: IncentivePeriod,
                    stateName: "period"
                },
                {
                    label: "User Selection",
                    component: UserSelection,
                    stateName: "user"
                },
                {
                    label: "KPI Selection",
                    component: KpiSelection,
                    stateName: "kpi"
                },
                {
                    label: "Incentive Name",
                    component: IncentiveName,
                    stateName: "incentiveName"
                }
            ],
            preview: DefineIncentivePreview
        }
    },
    {
        tabName: "Define Eligibility",
        tabDefinition: {
            tabComponents: [
                {
                    label: "Calculate Threshold",
                    component: CalculateThreshold,
                    stateName: "threshold",
                }
            ],
        }
    },
    {
        tabName: "Define Validity",
        tabDefinition: {
            tabComponents: [
                {
                    label: "Incentive Validity",
                    component: ValidityDate,
                    stateName: "storedDates",
                }
            ],
        }
    },

]

interface TabConfig {
    tabName: string
    tabDefinition: TabDefinitionType
}

export interface TabDefinitionType {
    tabComponents: TabComponentType[]
    preview?: (props: {setPreviewOpen:React.Dispatch<React.SetStateAction<boolean>>}) => JSX.Element
}

export interface TabComponentType {
    label: string
    component: (props: { stateName: string }) => JSX.Element
    stateName: string
}